import React, { useState, useEffect } from "react";
import ExamSummeryList from "./ExamSummeryList";
import { getMyAllExam } from "../../services/ExamService";
import SkeletonContainer, { getSkeletonHeight } from "../../loaders/SekletonContainer";

export default function ExamInProgress(props) {
  const [examListsRow, setExamListRow] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true
    getMyAllExam()
      .then((res) => {
        if (mounted) {
        setExamListRow(res.data.examList);
        setLoading(false);
      }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });

      return function cleanup() {
        setExamListRow([]);
        setLoading(true)
        mounted = false
    }
  }, []);
  return (
    <>
      {loading
        ? <SkeletonContainer height={getSkeletonHeight(25)} />
        : (
          <ul className="card-grid exam-ul-list list-unstyled">
            {examListsRow?.map((examDetails, index) => (
              !examDetails.showCompleted
                ? <ExamSummeryList key={index} exam={examDetails} />
                : null
            ))}
          </ul>
        )}
    </>
  );
}
